import "./index.scss";
import { DSButton } from "components/UI/atoms";
import { BrandCashInputRange } from "..";

export const BrandCashAmounts = ({
  selected,
  setSelected,
  inputValue,
  setInputValue,
  denominations,
  increment,
  max_value,
  min_value
}) => {
  const hasInputRange = !!(increment && max_value && min_value);
  const totalItems = denominations.length + Number(!!hasInputRange);
  const gridRows = totalItems === 1 ? 1 : 2;
  const gridColumns = Math.ceil(totalItems / 2);
  const isOdd = totalItems % 2 !== 0;
  const centsMultiplier = 0.01;

  const sortedAmountList = denominations.sort((a, b) => b - a);

  return (
    <div
      className={`brand-cash-amounts${isOdd ? " fill-last-row" : ""}`}
      style={{
        gridTemplateColumns: `repeat(${gridColumns}, 1fr)`,
        gridTemplateRows: `repeat(${gridRows}, 1fr)`
      }}
    >
      {sortedAmountList.map((amount) => (
        <DSButton
          customClassName={`amount-item amount-button${
            selected === amount ? " selected" : ""
          }`}
          type="outlined"
          size="small"
          onClick={() => setSelected(amount)}
          key={amount}
        >
          ${amount * centsMultiplier}
        </DSButton>
      ))}
      {hasInputRange && (
        <BrandCashInputRange
          value={inputValue}
          selected={selected === "input"}
          selectInput={() => setSelected("input")}
          onChange={setInputValue}
          increment={increment}
          max_value={max_value}
          min_value={min_value}
        />
      )}
    </div>
  );
};
